import React from 'react'
import ReactTooltip from 'react-tooltip'
import { getIcon } from '../getIcon'

import './SkillItem.scss'

interface IProps {
  subtitle: string
  xp: number
  icon: string
  description?: string
}

export function SkillItem({ subtitle, xp, icon, description }: IProps) {
  const iconImage = getIcon(icon)

  return (
    <div className="skill-item" data-for={subtitle} data-tip={description}>
      {description && (
        <ReactTooltip
          html
          multiline
          effect="solid"
          place="bottom"
          delayUpdate={500}
          delayHide={250}
          id={subtitle}
          className="skillset-item__tooltip"
        />
      )}
      <img className="skill-item__img" src={iconImage.x} alt={`${icon} icon`} />
      <div className="skill-item__labels">
        <div className="skill-item__xp-amount">{xp} XP</div>
        <div className="skill-item__subtitle">{subtitle}</div>
      </div>
    </div>
  )
}
